







import Vue from "vue";

export default Vue.extend({
    name: "CardProperty",
    props: {
        /** the value of the card property */
        value: { type: String, default: null },
        /** the label of the card property */
        label: { type: String, default: null },
        /** whether the value of the card property can resize itself */
        grow: { type: Boolean }
    }
});
